import {FaStar} from "react-icons/fa";
import Avatar from "@/components/General/Avatar";
import Link from "next/link";
import Image from "next/image";

export default function CoachLandingCard({job,speciality, description, firstname, lastname, rates,id,path,hourlyRates,withShaddow = false}){
    let ratesVal = rates ? rates : 0;
    return(
        <div className={` rounded-2xl bg-white mx-5  md:mx-0 ${withShaddow ? ' border shadow-2xl' : ''}`}>
            <div className={"h-[30vh]"}>
                <Link href={`/profile/${id}`}>
                    <img src={path ? path : "/logo_variant.svg"} alt={firstname} className={"rounded-t-2xl rounded-br-2xl w-full h-full object-cover "}/>
                </Link>
            </div>
            <div className={"h-[25vh] px-2 flex flex-col justify-between "}>
                <div className={"flex flex-col gap-2"}>
                    <h3 className={"font-semibold truncate text-primary max-w-[19rem] lg:max-w-none"}>{job} {speciality}</h3>
                    <p className={"text-gray-500"}>{firstname} {lastname}</p>
                    {ratesVal > 0 && (
                        <div className={"flex items-center gap-x-1"}>
                            <FaStar size={16} color={`FFCA00`}/> <p className={"text-sm"}><span className={"font-semibold"}>{parseFloat(ratesVal).toFixed(0)}</span> ({rates.length} avis)</p>
                        </div>
                    )}
                    {hourlyRates && (
                        <p className={"text-sm"}><span className={"font-semibold"}>{hourlyRates}€</span> / 1h00</p>
                    )}
                </div>

                <div className={"flex justify-center py-2"}>
                    <Link href={`/profile/${id}`}>
                        <button className={"rounded-full bg-primary px-4 py-2 text-white text-sm"}>Voir l&apos;offre</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

/*
return(
        <Link href={`/profile/${id}`}>
            <div className={`relative ${withShaddow ? 'shadow-2xl rounded-b-3xl' : ''}`}>
                <div className={"bg-cwfGreen text-center text-white rounded-t-3xl "}>
                    <div className={"pb-5 px-5 pt-24 grid gap-4"}>
                        <h3 className={"uppercase text-2xl font-bold"}>{job}</h3>
                        <p className={"max-w-[16rem] mx-auto truncate overflow-hidden"}>{description}</p>
                    </div>
                </div>
                <div className={"py-10 bg-white rounded-b-3xl"}>
                    <p className={"font-semibold text-center text-lg"}>{firstname} {lastname}</p>
                    <div className={`flex gap-x-2 justify-center pt-10`}>

                        <FaStar size={24} color={`${ratesVal > 0 ? 'FFCA00' : '000000'}`}/>
                        <FaStar size={24} color={`${ratesVal > 1 ? 'FFCA00' : '000000'}`}/>
                        <FaStar size={24} color={`${ratesVal > 2 ? 'FFCA00' : '000000'}`}/>
                        <FaStar size={24} color={`${ratesVal > 3 ? 'FFCA00' : '000000'}`}/>
                        <FaStar size={24} color={`${ratesVal > 4 ? 'FFCA00' : '000000'}`}/>
                    </div>
                </div>
                <div className={"absolute -top-[10%] left-1/2 -translate-x-1/2 z-50"}>
                    <Avatar width={100} height={100} url={path}/>
                </div>
            </div>
        </Link>
    )
 */